module.exports = __webpack_public_path__ + "static/img/douying.bdcd573.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/douying.png
// module id = fSCN
// module chunks = 22